<!--eslint-disable-->
<template>
<div id="app">
    <el-container id="main-container">
        <el-aside width="auto">
            <el-menu id="main-menu" default-active="1" class="el-menu-vertical-demo" :collapse="isCollapse"
                :router="true" :collapse-transition="false" background-color="#545c64" text-color="#fff"
                active-text-color="#ffd04b" v-if="isLogged">
                <el-menu-item @click="toggleCollapse" :index="$route.path" >
                    <i :class="isCollapseIcon"></i>
                    <span slot="title">Leblon Equities</span>
                </el-menu-item>
                <el-menu-item index="home" v-if="visible('home')">
                  <FSIcon name="home"></FSIcon>
                  <span slot="title">Home</span>
                </el-menu-item>
                <el-submenu v-if="visible('coverageDash')" index="analise">
                    <template slot="title">
                        <FSIcon name="trending-up"></FSIcon>
                        <span>Análise</span>
                    </template>
                    <el-menu-item index="coverageDash">
                        <FSIcon></FSIcon>
                        <span slot="title">Dashboard Cobertura</span>
                    </el-menu-item>
                    <el-menu-item index="monitorAcoes">
                        <FSIcon></FSIcon>
                        <span slot="title">Monitor de Ações</span>
                    </el-menu-item>
                    <el-menu-item index="gerarMultipagers">
                        <FSIcon></FSIcon>
                        <span slot="title">Gerar Multipagers</span>
                    </el-menu-item>
                </el-submenu>
                <el-submenu v-if="visible('finReport')" index="backoffice">
                    <template slot="title">
                        <FSIcon name="settings"></FSIcon>
                        <span>Backoffice</span>
                    </template>
                    <el-menu-item index="finReport">
                        <FSIcon></FSIcon>
                        <span slot="title">Financial Report</span>
                    </el-menu-item>
                    <el-submenu index="rebate">
                        <template slot="title">
                            <FSIcon></FSIcon>
                            <span>Rebate</span>
                        </template>
                        <el-menu-item index="rebateRegras">
                            <FSIcon></FSIcon>
                            <span slot="title">Regras</span>
                        </el-menu-item>
                        <el-menu-item index="rebateCalculo">
                            <FSIcon></FSIcon>
                            <span slot="title">Cálculo</span>
                        </el-menu-item>
                    </el-submenu>
                </el-submenu>
                <el-submenu v-if="visible('cadastroCotistas')" index="movimentacoes">
                    <template slot="title">
                        <FSIcon name="credit-card"></FSIcon>
                        <span>Movimentações</span>
                    </template>
                    <el-menu-item index="cadastroCotistas">
                        <FSIcon></FSIcon>
                        <span slot="title">Cadastro de cotistas</span>
                    </el-menu-item>
                    <el-menu-item index="movimentacoes">
                        <FSIcon></FSIcon>
                        <span slot="title">Movimentações</span>
                    </el-menu-item>
                    <el-menu-item index="distribuidoras">
                        <FSIcon></FSIcon>
                        <span slot="title">Distribuidoras</span>
                    </el-menu-item>
                </el-submenu>
                <el-submenu v-if="visible('rotinasComercial')" index="comercial">
                    <template slot="title">
                        <FSIcon name="phone-call"></FSIcon>
                        <span>Comercial</span>
                    </template>
                    <el-menu-item index="rotinasComercial">
                        <FSIcon></FSIcon>
                        <span slot="title">Rotina Mensal</span>
                    </el-menu-item>
                    <el-menu-item index="rotinaEnvioArquivosSemanal">
                        <FSIcon></FSIcon>
                        <span slot="title">Rotina Semanal</span>
                    </el-menu-item>
                    <el-menu-item index="rotinaEnvioExtratoComercial">
                        <FSIcon></FSIcon>
                        <span slot="title">Envio de Extrato</span>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item index="userRoleEdit" v-if="visible('userRoleEdit')">
                    <FSIcon name="users"></FSIcon>
                    <span slot="title">Usuários</span>
                </el-menu-item>
                <el-menu-item @click="logout" :index="$route.path">
                    <FSIcon name="log-out"></FSIcon>
                    <span slot="title">Sair</span>
                </el-menu-item>
            </el-menu>
        </el-aside>

        <el-main>
            <!--<el-alert type="warning" effect="dark"></el-alert>-->
            <el-alert class="alert-app" v-show="alert_visible" :title="alert_title" :type="alert_type" @close="changeAlertVisibility" effect="dark"></el-alert>
            <router-view/>
        </el-main>

    </el-container>
</div>
</template>

<style>
#main-container {
  height: 97.5vh;
}

#main-menu {
  min-height: 100%;
}
</style>

<script>
/* eslint-disable */
import firebase from 'firebase/app'

export default {
    name: 'app',
    data() {
        return {
            isCollapse: true,
            userRole: null,
            currentUser: false,
            alert_title: '',
            alert_type: '',
            alert_visible: false
        }
    },
    methods: {
        toggleCollapse() {
            this.isCollapse = !this.isCollapse
        },
        logout() {
            firebase.auth().signOut().then(() => {
                this.$router.replace('login')
                this.currentUser = false
            })
        },
        visible(routeName) {
            var route = this.$router.options.routes.filter(route => route.name == routeName)[0]
            if(route === undefined) return false;
            return route.meta.roles.includes(this.userRole)
        },
        changeAlertVisibility() {
            this.alert_visible = false
        }
    },
    computed: {
        isCollapseIcon() {
            return this.isCollapse ? 'el-icon-menu' : 'el-icon-arrow-left'
        },
        isLogged() {
            return this.currentUser 
        }
    },
    async updated() {
        if(firebase.auth().currentUser === null) return this.userRole = null;
        this.currentUser = firebase.auth().currentUser
        var idTokenResult = await firebase.auth().currentUser.getIdTokenResult()
        return this.userRole = idTokenResult.claims.role;
    },
    mounted() {
        this.$root.$on('showError', (title, type) => {
            this.alert_title = title
            this.alert_type = type
            this.alert_visible = true
        })
    }
}
</script>

<style scoped>
.alert-app {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: auto;
    margin: 0 auto;
}
.el-main {
    padding-top: 0px;
}
.alert-app >>> span {
    font-size: 18px;
}

</style>